import {ToggleButtonGroup, Tooltip} from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import {isNull} from 'lodash';
import clsx from 'clsx';
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {VIP_SCORE_DATA} from './visualInfusionPhlebitisModal';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.mode === 'light' ? '#b0b0b0' : '#393939',
        width: 'fit-content',
        borderRadius: 5,
    },
    label: {
        fontFamily: 'Inter',
        fontWeight: 400,
        textTransform: 'none',
        color: theme.palette.mode === 'light' ? '#2a2a2a' : '#929292',
        border: 'none',
        minWidth: 40,
        height: 30,
        '&:hover': {
            color: theme.palette.mode === 'light' ? '#000000' : '#ffffff',
        },
        '&.Mui-disabled': {
            border: 'none',
        },
        '&.first': {
            backgroundColor: '#01AF69',
            color: '#FFF',
        },
        '&.second': {
            backgroundColor: '#FEB03A',
            color: '#FFF',
        },
        '&.third': {
            backgroundColor: '#DC4A5D',
            color: '#FFF',
        },
    },
    selected: {
        '&&': {
            backgroundColor: '#ffffff',
            color: '#3A3A3A',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#ffffff',
                color: '#3A3A3A',
            },
        },
        '&.Mui-disabled': {
            backgroundColor: '#929292',
            border: 'none',
        },
    },
    block: {
        padding: 4,
    },
}));

const VisualInfusionPhlebitisSelect = ({value, onChange, openDialog, disabled}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    const getVal = () => isNull(value) ? 'null' : value;

    const handleChange = (e, value) => {
        if (typeof value !== 'object') {
            let val = value;
            if (val === 'null') val = null;
            onChange(val, e);
        }
    };

    const getTooltipTitle = (index) => {
        const item = VIP_SCORE_DATA.find(i => i.id === index);
        return item?.action || '';
    };

    return (
        <>
            <Tooltip title={t('Open Visual Infusion Phlebitis (VIP) Score Table')}>
                <IconButton
                    disableRipple
                    onClick={openDialog}
                    size="small"
                >
                    <HelpOutlineIcon/>
                </IconButton>
            </Tooltip>

            <div className={classes.root}>
                <ToggleButtonGroup
                    value={getVal()}
                    exclusive
                    onChange={handleChange}
                    disabled={disabled}
                    className={classes.block}
                    size="small"
                    orientation="horizontal"
                    sx={{
                        gridGap: '5px',
                    }}
                >
                    <ToggleButton
                        className={clsx(classes.label, 'first')}
                        classes={{selected: classes.selected}}
                        sx={{
                            '&.MuiToggleButtonGroup-grouped': {
                                borderRadius: '5px !important',
                            },
                        }}
                        value="0"
                    >
                        <Tooltip title={getTooltipTitle(0)}>
                            <span>0</span>
                        </Tooltip>
                    </ToggleButton>

                    <ToggleButton
                        className={clsx(classes.label, 'second')}
                        classes={{selected: classes.selected}}
                        sx={{
                            '&.MuiToggleButtonGroup-grouped': {
                                borderRadius: '5px !important',
                            },
                        }}
                        value="1"
                    >
                        <Tooltip title={getTooltipTitle(1)}>
                            <span>1</span>
                        </Tooltip>
                    </ToggleButton>

                    <ToggleButton
                        className={clsx(classes.label, 'third')}
                        classes={{selected: classes.selected}}
                        sx={{
                            '&.MuiToggleButtonGroup-grouped': {
                                borderRadius: '5px !important',
                            },
                        }}
                        value="2"
                    >
                        <Tooltip title={getTooltipTitle(2)}>
                            <span>2</span>
                        </Tooltip>
                    </ToggleButton>

                    <ToggleButton
                        className={clsx(classes.label, 'third')}
                        classes={{selected: classes.selected}}
                        sx={{
                            '&.MuiToggleButtonGroup-grouped': {
                                borderRadius: '5px !important',
                            },
                        }}
                        value="3"
                    >
                        <Tooltip title={getTooltipTitle(3)}>
                            <span>3</span>
                        </Tooltip>
                    </ToggleButton>

                    <ToggleButton
                        className={clsx(classes.label, 'third')}
                        classes={{selected: classes.selected}}
                        sx={{
                            '&.MuiToggleButtonGroup-grouped': {
                                borderRadius: '5px !important',
                            },
                        }}
                        value="4"
                    >
                        <Tooltip title={getTooltipTitle(4)}>
                            <span>4</span>
                        </Tooltip>
                    </ToggleButton>

                    <ToggleButton
                        className={clsx(classes.label, 'third')}
                        classes={{selected: classes.selected}}
                        sx={{
                            '&.MuiToggleButtonGroup-grouped': {
                                borderRadius: '5px !important',
                            },
                        }}
                        value="5"
                    >
                        <Tooltip title={getTooltipTitle(5)}>
                            <span>5</span>
                        </Tooltip>
                    </ToggleButton>

                    <ToggleButton
                        className={classes.label}
                        classes={{selected: classes.selected}}
                        sx={{
                            '&.MuiToggleButtonGroup-grouped': {
                                borderRadius: '5px !important',
                            },
                        }}
                        value="null"
                    >
                        {t('Not Required')}
                    </ToggleButton>

                    <ToggleButton
                        className={classes.label}
                        classes={{selected: classes.selected}}
                        sx={{
                            '&.MuiToggleButtonGroup-grouped': {
                                borderRadius: '5px !important',
                            },
                        }}
                        value={false}
                    >
                        {t('No')}
                    </ToggleButton>
                </ToggleButtonGroup>
            </div>
        </>
    );
};

export default VisualInfusionPhlebitisSelect;